<template>
  <div class="data modal-container">
    <div class="modal-header">
      <div class="corner-container left">
        <div>
          <div class="header-label"> <b> {{ headerText }} </b> </div>
        </div>
        <div>
          <div class="helper-text"> <b>Visitor Relationship:</b> </div>
          <p class="helper-text-data"> {{ visitorRelationship }}</p>
        </div>
      </div>
      <div>
        <div class="circle">
          <button style="width: 100%; height: 100%;" @click="changeAssignee()">
            {{ userInitials }}
          </button>
        </div>
      </div>

      <div class="corner-container right">
        <button class="header-label" @click="$emit('close')">X</button>
        <div>
          <div class="helper-text"> <b>Visitor ID:</b> </div>
          <p class="helper-text-data"> {{ userId }}</p>
        </div>
      </div>

    </div>
    <div class="modal-fields">
      <div class="modal-field">
        <div class="helper-text">Frequent Visitor Name</div>
        <p class="center-text"> {{ name }}</p>
      </div>
      <div class="modal-field">
        <div class="helper-text">Resident Name</div>
        <p class="center-text"> {{ residentName }}</p>
      </div>
      <div class="modal-field">
        <div class="helper-text">Resident Phone Number</div>
        <p class="center-text"> {{ phone }}</p>
      </div>
      <div class="modal-field">
        <div class="helper-text">Visiting Address</div>
        <p class="center-text"> {{ address }}</p>
      </div>
      <div class="modal-field">
        <div class="helper-text">Visitor License Plate</div>
        <p class="center-text"> {{ licensePlate }}</p>
      </div>
      <div class="modal-field">
        <div class="helper-text">Visitor Vehicle Type</div>
        <p class="center-text"> {{ vehicleType }}</p>
      </div>

      <!-- <div class="modal-field">
        <div class="helper-text"> Associated Users</div>
        <p v-for="associatedUser in associatedUsers" :key="associatedUser.toString()" class="center-text"> {{
          associatedUser.user_first_name }} {{ associatedUser.user_last_name }}: {{ associatedUser.unit_association }}
        </p>
      </div> -->
    </div>


    <div class="additional-data">
      <div class="additional-data-item">
        <b>
          <p>Date Added</p>
        </b>
        <br>
        <p>{{ dateAdded }}</p>
      </div>
      <div style="display:block; width: 1px; height: 100%; background-color: white;"></div>
      <div class="additional-data-item">
        <b>
          <p>Expiration Date</p>
        </b>
        <br>
        <p>{{ expiration }}</p>
      </div>
      <div style="display:block; width: 1px; height: 100%; background-color: white;"></div>
      <div class="additional-data-item">
        <b>
          <p>Last Scanned</p>
        </b>
        <br>
        <p>{{ lastScanned }}</p>
      </div>
      <div style="display:block; width: 1px; height: 100%; background-color: white;"></div>
      <div class="additional-data-item">
        <b>
          <p>Times Visited</p>
        </b>
        <br>
        <p>{{ timesVisited }}</p>
      </div>

    </div>


    <div class="button-container"
      v-if="userData['custom:cts_role'] == 'admin' || userData['custom:cts_role'] == 'hoa_admin' || userData['custom:cts_role'] == 'guard'">
      <div class="modal-triple-button-row">
        <button class="resend button" @click="resendUserInvitation()">Resend Key</button>
        <button class="update button" @click="editUser()">Update Key</button>
        <button class="cancel button" @click="editUser()">Cancel Key</button>
      </div>
      <button class="validate button" @click="createEntryLog()">Log Entry</button>
    </div>
    <div v-else>
      <div class="button-container">
        <button class="action-button" @click="editUser()">Edit User</button>
        <!-- <button class="action-button" @click="addSecondaryUser()">Add Secondary User</button> -->
      </div>
    </div>

  </div>
</template>

<script>
import EventBus from '../../../eventBus.js';
import CTSRepository from '../../../js/CTSRepository';
// import EditUserModal from '../edit/EditUserModal.vue';
// import GeneralNotificationModal from '../notification/GeneralNotificationModal.vue';

const NAME = 'visitor-modal'

export default {
  modalName: NAME,
  props: ["selectedVisitorData", "organizationData", "userData"],
  components: {
  },
  data() {
    return {
      modalName: NAME,
      suspended: false,
      inactive: true,
      showId: false,
      currentVisitorData: this.$props.selectedVisitorData,
      currentCognitoData: null
    }
  },
  computed: {
    headerText: function () {
      return `${this.getMappedName(this.$props.organizationData.organization_id)}`
    },
    userInitials: function () {
      const first = this.currentVisitorData.visitor_first_name[0]
      const second = this.currentVisitorData.visitor_last_name[0]
      return `${first}${/^[A-Za-z]$/.test(second) ? `${second}` : ``}`
    },
    moveInDate: function () {
      return ``
    },
    visitorRelationship: function () {
      return `${this.currentVisitorData.current_status}`
    },
    status: function () {
      return ``
    },
    userId: function () {
      return this.currentVisitorData.visitor_id
    },
    name: function () {
      return `${this.currentVisitorData.visitor_first_name} ${this.currentVisitorData.visitor_last_name}`
    },
    residentName: function () {
      const user = this.currentVisitorData.user_data
      return `${user.first_name} ${user.last_name}`
    },
    phone: function () {
      return this.currentVisitorData.user_data.phone
    },
    address: function () {
      const units = this.currentVisitorData.user_data.units.map(it => it.unit_address)
      // const unit = this.currentVisitorData.user_data.unit_data
      return units.join(', ')
    },
    licensePlate: function () {
      return ``
    },
    vehicleType: function () {
      return ``
    },
    dateAdded: function () {
      return `${new Date(this.currentVisitorData.time_created).toLocaleDateString()}`

    },
    expiration: function () {
      const expiration = this.currentVisitorData.expiration
      if (expiration == null) {
        return "N/A"
      }
      return `${new Date(this.currentVisitorData.expiration).toLocaleDateString()}`

    },
    lastScanned: function () {
      return `${new Date(this.currentVisitorData.time_created).toLocaleDateString()}`
    },
    timesVisited: function () {
      return `${this.currentVisitorData.times_visited}`
    },
    role: function () {
      return "this.$roleNameMap[this.currentUserData.role]"
    },
    // associatedUsers: function () {
    //   if (this.$props.unitData.associated_users.length > 0 && this.$props.unitData.associated_users[0] != null) {
    //     return this.$props.unitData.associated_users
    //   }
    //   return null
    // }
  },
  methods: {
    show() {
      this.$modal.show();
    },
    close() {
      this.$modal.hide();
    },
    showKey() {
      console.log("show key...")
    },
    showIncidents() {
      console.log("show incidents...")
    },
    edit() {
      console.log("edit mode!")
    },
    fetchUser() {
      // new CTSRepository(this.$props.organizationData).fetchUser(this.$props.selectedUserData.uid).then(result => {
      //   this.currentUserData = result.data.userData[0]
      //   this.currentCognitoData = result.data.cognitoData
      // })
    },
    editUser() {
      alert("This feature is disabled, please try again later")
      return
      // this.$modal.show(EditUserModal, {
      //   userData: this.currentUserData,
      //   organizationData: this.$props.organizationData,
      //   title: `Update User`,
      //   message: "Please update the following fields that you would like to update.",
      //   confirmText: "Update",
      //   cancelText: "Cancel",
      //   onConfirm: async (data) => {
      //     try {
      //       const result = await new CTSRepository(this.$props.organizationData).updateUser(this.$props.selectedUserData.uid, JSON.stringify(data))
      //       this.handleUpdateUserResponse(result.data)
      //       await this.notifyReload()
      //     } catch (e) {
      //       alert(e)
      //     }

      //   }
      // }, {
      //   width: 450,
      //   height: 'auto',
      //   adaptive: true,
      //   clickToClose: false
      // })
    },
    addSecondaryUser() {
      console.log("add user...")
    },
    resendUserInvitation() {
      alert("This feature is disabled, please try again later")
      return
      // if (this.currentUserData.current_status == 'Deactivated') {
      //   alert("User is Deactivated, invitation cannot be sent")
      //   return
      // }
      // this.$modal.show(GeneralNotificationModal, {
      //   userData: this.currentUserData,
      //   organizationData: this.$props.organizationData,
      //   title: `Resend Activation for ${this.name}`,
      //   message: `Are you sure you want to resend ${this.name}'s activation email?`,
      //   disclaimer: `By clicking Yes, this user will receive a temporary password from Community Tech through email and will need to reset their password before accessing the platform.`,
      //   confirmText: "Yes",
      //   cancelText: "No",
      //   onConfirm: async () => {
      //     try {
      //       await new CTSRepository(this.$props.organizationData).resendUserInvitation(this.$props.selectedUserData.uid)
      //       await this.fetchUser()
      //       await this.notifyReload()
      //     } catch (e) {
      //       console.error("Error Resending User Invitation", e)
      //     }
      //   }
      // }, {
      //   width: 550,
      //   height: 'auto',
      //   adaptive: true,
      //   clickToClose: true
      // })


    },
    notifyReload() {
      EventBus.$emit("refreshData")
    },
    handleUpdateUserResponse(newUserData) {
      this.currentUserData = newUserData
      this.notifyReload()
    },
    suspendUser() {
      // this.$modal.show(GeneralNotificationModal, {
      //   userData: this.currentUserData,
      //   organizationData: this.$props.organizationData,
      //   title: `Deactivate Account for ${this.name}`,
      //   message: `Are you sure you want to deactivate ${this.name}'s account?`,
      //   disclaimer: `By clicking Yes, this user will no longer be able to access the Gatewatch platform and will be removed from all associated modals for user selection. This user will not able to be reactivated without a Community Tech user.`,
      //   confirmText: "Yes",
      //   cancelText: "No",
      //   onConfirm: async () => {
      //     try {
      //       await new CTSRepository(this.$props.organizationData).updateUser(this.$props.selectedUserData.uid,
      //         JSON.stringify({
      //           first_name: "",
      //           last_name: "",
      //           address: "",
      //           primary_email_address: "",
      //           primary_phone_number: "",
      //           secondary_email_address: "",
      //           secondary_phone_number: "",
      //           subdivision: "",
      //           role: "",
      //           current_status: 'Deactivated'
      //         })
      //       )
      //       await this.fetchUser()
      //       await this.notifyReload()
      //     } catch (e) {
      //       console.error("Error Suspending User", e)
      //     }
      //   }
      // }, {
      //   width: 550,
      //   height: 'auto',
      //   adaptive: true,
      //   clickToClose: true
      // })

    },
    activateUser() {
      // this.$modal.show(GeneralNotificationModal, {
      //   userData: this.currentUserData,
      //   organizationData: this.$props.organizationData,
      //   title: `Activate Account for ${this.name}`,
      //   message: `Are you sure you want to activate ${this.name}'s account?`,
      //   disclaimer: `By clicking Yes, this user will get access to the Gatewatch Platform according to their role: ${this.$roleNameMap[this.currentUserData.role]}`,
      //   confirmText: "Yes",
      //   cancelText: "No",
      //   onConfirm: async () => {
      //     try {
      //       await new CTSRepository(this.$props.organizationData).updateUser(this.$props.selectedUserData.uid,
      //         JSON.stringify({
      //           first_name: "",
      //           last_name: "",
      //           address: "",
      //           primary_email_address: "",
      //           primary_phone_number: "",
      //           secondary_email_address: "",
      //           secondary_phone_number: "",
      //           subdivision: "",
      //           role: "",
      //           current_status: 'Active'
      //         })
      //       )
      //       await this.fetchUser()
      //       await this.notifyReload()
      //     } catch (e) {
      //       console.error("Error Activating User", e)
      //     }
      //   }
      // }, {
      //   width: 550,
      //   height: 'auto',
      //   adaptive: true,
      //   clickToClose: true
      // })
    },
    showUserId() {
      this.showId = true
    },
    hideUserId() {
      this.showId = false
    },
    uploadAttachment() {
      alert("Upload Attachment")
    },
    changeAssignee() {
      alert("Change Assignee")
    },
    createEntryLog() {
      let body = {
        "type": "Visitor",
        "action": "ADMIT",
        "authorizer": this.userData.sub,
        "entity_id": this.currentVisitorData.visitor_id,
        "resident_uid": this.currentVisitorData.resident_uid,
        "visitor_first_name": this.currentVisitorData.visitor_first_name,
        "visitor_last_name": this.currentVisitorData.visitor_last_name,
        "visitor_license_plate": "",
        "visitor_contact": this.currentVisitorData.visitor_phone_number,
        "visitor_type": this.currentVisitorData.visitor_type,
        "visitor_vendor_name": this.currentVisitorData.visitor_vendor_name,
        "party_key": this.currentVisitorData.user_data.unit_data.unit_id,
        "visit_id": ""
      }
      console.log("Create Entry Log Body", body)

      new CTSRepository(this.$props.organizationData).createEntryLog(body).then(response => {
        console.log("Create Entry Log Response", response);
        this.$emit('close');
      }).catch(err => console.error(err))
    },
    updateIncident() {
      alert("Update Incident")

    },
    getMappedName(id) {
      return this.$organizationMap[id] ?? id
    },
    mapCognitoRoleToUserMessage(status) {
      switch (status) {
        case "FORCE_CHANGE_PASSWORD": {
          return "Has not signed in"
        }
        case "CONFIRMED": {
          return "Has signed in"
        }
        case "RESET_REQUIRED": {
          return "Must Reset Password"
        }
        case "EXTERNAL_PROVIDER": {
          return "SSO"
        }
        default: {
          return ""
        }
      }
    }
  },
  created() {
    console.log("In modal")
    // make API request here to fill out payload fields
    // fetch or use axios?
  },
  mounted() {
    this.fetchUser()
  }
}
</script>

<style>
.modal-container {
  display: flex;
  flex-direction: column;
  background-color: #699991;
  color: white;
  border-radius: 4px;
}

.modal-header {
  padding: 1rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.modal-field {
  padding: 1rem;
  font-size: 25px;
  border-bottom: 1px solid #87BAB7;
}

.modal-time-info {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}

.modal-time-inner {
  display: flex;
  flex-direction: column;
  padding: 1rem;
  border-right: 1px solid #87BAB7;
  border-left: 1px solid #87BAB7;
}

.helper-text {
  text-align: left;
  font-size: 15px;
}

.circle {
  width: 160px;
  height: 160px;
  line-height: 160px;
  border-radius: 50%;
  font-size: 50px;
  color: #fff;
  text-align: center;
  background: #87BAB7;
}

/* .action-button {
    margin: .5rem;
    color: white;
    background-color: #87BAB7;
    width: 45%;
    margin-left: auto;
    margin-right: auto;
    height: 3rem;
    border-radius: 5px;
  }
  .suspended-button {
    margin: .5rem;
    color: white;
    background-color: red;
    width: 45%;
    margin-left: auto;
    margin-right: auto;
    height: 3rem;
    border-radius: 5px;
  } */
.suspended-text {
  color: red;
}

.corner-container {
  display: flex;
  flex-direction: column;
}

.mini-text {
  padding-top: 5px;
  font-size: 12px;
}
</style>
